import React, {
    useState,
    useEffect
} from "react"

import { 
    Form, 
    InputGroup, 
    Button,
    Spinner,
} from "react-bootstrap"

import { 
    Search,
    Trash, 
} from "react-bootstrap-icons"
import UnitTreeTools from "../../../Model/UnitTree.m"
import {
    ListGroup
} from "react-bootstrap"
import { Flex } from "@aws-amplify/ui-react"
import EMETLButton from "../EMETLButton"

const UnitTree = new UnitTreeTools()
let finalActionParams = {}

const DynamicModal = ({ content }) => {
    const {
        onSave,
        removeUser,
        searchBarText,
        onSearchSubmit,
        bodyContent,
        data,
        fromUnitText,
        searchSelectionLabel,
        actionLabel,
        finalAction,
    } = content

    const [needle, setNeedle] = useState("")
    const [loading, setLoading] = useState(true)
    const [personnel, setPersonnel] = useState([])
    const [searchResults, setResults] = useState([])
    const [currentUnit, setCurrentUnit] = useState(undefined)
    const [searchSelection, setSearchSelection] = useState(undefined)
    const loadUnit = async () => {
        setLoading(true)
        let u
        if (data?.unit?.unitID < 1) {
            u = data
        } else {
            u = await UnitTree.loadUnit(data.unit.unitID)
        }
        if (data.listPersonnel) {
            const p = await UnitTree.listPersonnelAtUnit(u.unitID, u.depth)
            
            if (!!p?.result?.length && p?.result) {
                try {
                    const listPersonnelResponse = JSON.parse(p?.result)
                    const result = listPersonnelResponse?.body?.result
                    if (result && !!result?.length)
                        setPersonnel(result[0])

                } catch (e) {
                    console.error(e)
                }
                
            }
        }
        setLoading(false)
        setCurrentUnit(u)
    }

    const handleSearchSelection = (result) => {
        setSearchSelection(result)
        setNeedle(result.Name)
        setResults([])
    }

    const handleFinalAction = () => {
        finalActionParams = {
            fromUnitID: currentUnit.unitID,
            fromUnitDepth: currentUnit.depth,
            callback: onSave,
            parentID: data.unit.unitID > 0 ? currentUnit.unitID : null,
            depth: (currentUnit.depth ?? 0) + 1,
            name: data?.unitName,
            leaderID: searchSelection?.ID,
            userID: searchSelection?.ID,
            unitID: data.unit.unitID,
            searchSelection: searchSelection ?? null,
        }

        finalAction(finalActionParams)
    }

    useEffect(
        () => {
            loadUnit()
            
        }, []
    )

    const handleSearch = async (e) => {
        e.preventDefault()
        onSearchSubmit(needle, setResults)
    }

    const getDynamicText = (oldText) => {
        return oldText.replace("@@UNIT_NAME", currentUnit?.name)
    }
    
    return (
        <div id="unitTreeContextModal">
            {loading && <Spinner />}
            {bodyContent && !loading && <p>{getDynamicText(bodyContent)}</p>}
            {searchBarText && (
                <>
                    <Form onSubmit={handleSearch}>
                        <InputGroup className="mb-3">
                            <Form.Control
                                placeholder={searchBarText}
                                aria-label="search"
                                aria-describedby="basic-addon1"
                                onChange={(e) => setNeedle(e.target.value)}
                                value={needle}
                            />
                            <Button 
                                style={{
                                    borderRadius: "0px 5px 5px 0px"
                                }} 
                                type="submit" 
                                variant="outline-secondary" 
                                id="button-addon1"
                            >
                                <Search />
                            </Button>
                        </InputGroup>
                    </Form>
                    {!!searchResults.length && (
                        <>
                            <p className="h4">Search Results</p>
                            <ListGroup>
                                {searchResults.map(
                                    result => (
                                        <ListGroup.Item 
                                            key={result.ID} 
                                            onClick={
                                                () => {
                                                    handleSearchSelection(result)
                                                }
                                            }
                                        >
                                            {result.Name}
                                            {result.Email && <> — {result.Email}</>}
                                        </ListGroup.Item>
                                    )
                                )}
                            </ListGroup>
                        </>
                    )}
                    {fromUnitText && currentUnit && (
                        <div>
                            {fromUnitText}: {currentUnit.name}
                        </div>
                    )
                    }
                    {searchSelectionLabel && searchSelection && (
                        <div>
                            {searchSelectionLabel}: {searchSelection.Name}
                        </div>
                    )
                    }
                    {currentUnit && searchSelection && finalAction && actionLabel && (
                        <Button onClick={handleFinalAction}>
                            {actionLabel}
                        </Button>
                    )
                    }
                </>
            )}
            {!searchBarText && currentUnit && finalAction && actionLabel && (
                <Button onClick={handleFinalAction}>
                    {actionLabel}
                </Button>
            )}
            {!loading && currentUnit && !!personnel?.length && (
                <>
                    <p className="h4">Unit Personnel at {currentUnit.name}</p>
                    <ListGroup
                        style={{
                            flex: 1,
                        }}
                    >
                        {personnel.map(
                            result => (
                                <ListGroup.Item 
                                    key={result.ID} 
                                    style={{
                                        flex: 1,
                                    }}
                                    // onClick={
                                    //     () => {
                                    //         console.log(result)
                                    //     }
                                    // }
                                >
                                    <Flex
                                        direction={"row"}
                                        flex={1}
                                        grow="inherit"
                                    >
                                        <Flex>
                                            {result.Name}
                                            {result.Email && <> — {result.Email}</>}
                                        </Flex>
                                        <Flex
                                            justifyContent="flex-end"
                                            grow="inherit"
                                        >
                                            <Button
                                                variant="link"
                                                onClick={async () => {
                                                    await removeUser(result)
                                                }}
                                            >
                                                <Trash 
                                                    size={20}
                                                    color="grey"
                                                />
                                            </Button>
                                        </Flex>
                                    </Flex>
                                </ListGroup.Item>
                            )
                        )}
                    </ListGroup>
                </>
            )}
            
        </div>
    )
}

export default DynamicModal